import { AndroidOutlined, AppleOutlined } from '@ant-design/icons';
import { Tabs } from 'antd';
const FormTabs = (props, ref) => {

  const onClick = (key, event) => {
    console.log(key, typeof props.callback);
    console.log(event);
    props.callback('main');
  }
  return (
    <Tabs
      defaultActiveKey="2"
      onTabClick={onClick}
      items={[AppleOutlined, AndroidOutlined].map((Icon, i) => {
        const id = String(i + 1);
        return {
          label: (
            <span>
              <Icon />
              Tab {id}
            </span>
          ),
          key: id,
          children: `Tab ${id}`,
        };
      })}
    />
  )
}
export default FormTabs;